import React, { PropsWithChildren } from "react"

type MyProps = {
    className?: string
}

const ModalBody = ({children, className}: PropsWithChildren<MyProps>) => {
    return (
        <div className={`tw-px-6 tw-py-3.5 tw-flex-grow ${className ?? ""}`}>
            {children}
        </div>
    )
}
export default ModalBody